import React from "react";
import { motion } from "framer-motion";
import { Image_Url } from "../../Config/config";

export function Childlock(props) {
  if (props?.data?.is_child) {
    return (
      <motion.div
        className=""
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        key="1"
      >
        <div className="childLock-img">
          <img src={`${Image_Url}img/child-lock.png`} alt="Child Lock" />
        </div>
      </motion.div>
    );
  } else {
    return null
  }
}


